import React from 'react';
import { InfoIcon } from 'lucide-react';
import { pathwaySteps } from '../data/pathway';
import { SectionCta } from './SectionCta';
const stepColors = ['#3b7dd8', '#e8664f', '#2fa37a', '#8a5cd1', '#d9940f', '#2f93cc'];
export function Pathway() {
  return <section className="w-full bg-mist px-5 py-16 sm:py-24" aria-labelledby="pathway-title" data-id="element-243" data-mp="3c4qd2ng07ecr">
      <div className="mx-auto max-w-6xl lg:grid lg:grid-cols-[0.9fr_1.1fr] lg:gap-16" data-id="element-244" data-mp="37a2m8hxj27v0">
        <div className="lg:sticky lg:top-10 lg:self-start" data-id="element-245" data-mp="3lz8ka2kmps1b">
          <p className="text-xs font-bold uppercase tracking-[0.16em] text-brand sm:text-sm" data-id="element-246" data-mp="3h2rtt1pyj1l2">The Clinical Pathway™</p>
          <h2 id="pathway-title" className="mt-3 font-heading text-[1.9rem] font-semibold leading-[1.12] text-ink sm:text-4xl lg:text-[2.75rem]" data-id="element-247" data-mp="3v0gikkn5asve">
            From scattered motor observations to a structured working hypothesis in approximately 15 minutes.
          </h2>
          <p className="mt-4 text-[1.05rem] leading-relaxed text-ink/70 sm:text-lg" data-id="element-248" data-mp="1wmn9limjzrnu">
            A practical pathway to help you organize the information available in a case and identify the questions that
            deserve further exploration.
          </p>
          <p className="mt-6 hidden items-start gap-2 text-sm leading-relaxed text-ink/60 lg:flex" data-id="element-249" data-mp="2wpogbbzcox1u">
            <InfoIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-250" data-mp="31paubnn06hbp" />
            The 15-minute timeframe refers to a focused case-organization exercise, not a complete clinical assessment, a
            validated diagnostic procedure, or a guaranteed conclusion.
          </p>
        </div>

        <ol className="relative mt-10 lg:mt-0" data-id="element-251" data-mp="3fkd7mvu6j8yj">
          <span className="absolute bottom-6 left-[1.4rem] top-6 w-0.5 bg-line" aria-hidden="true" data-id="element-252" data-mp="3kin3l8nqadl7" />
          {pathwaySteps.map((step, i) => <li key={step.title} className="relative flex gap-4 pb-5 last:pb-0" data-id="element-253" data-mp="3pec71n2vcems" data-mpi={i}>
              <span className="relative z-10 flex h-12 w-12 shrink-0 items-center justify-center rounded-full font-heading text-xl font-bold text-white ring-4 ring-mist" style={{
            backgroundColor: stepColors[i]
          }} data-id="element-254" data-mp="1q5f4v5wmthua">
                {i + 1}
              </span>
              <div className="flex-1 rounded-2xl bg-white p-5 ring-1 ring-line" data-id="element-255" data-mp="1j2gzc91li6x4">
                <h3 className="font-heading text-xl font-semibold text-ink" data-id="element-256" data-mp="1x1qfx9tpr31m">{step.title}</h3>
                <p className="mt-1.5 leading-relaxed text-ink/70" data-id="element-257" data-mp="1s0avnjzd10ka">{step.text}</p>
              </div>
            </li>)}
        </ol>

        <p className="mt-8 flex items-start gap-2 text-sm leading-relaxed text-ink/60 lg:hidden" data-id="element-258" data-mp="25yhb7k0fydv5">
          <InfoIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-259" data-mp="21xff3c1tmhxe" />
          The 15-minute timeframe refers to a focused case-organization exercise, not a complete clinical assessment, a
          validated diagnostic procedure, or a guaranteed conclusion.
        </p>
      </div>
      <SectionCta label="I want a clearer motor planning reasoning system" data-id="element-260" data-mp="2pmq7o690p60g" />
    </section>;
}